import Header from "components/Headers/Header";
import StatsTableComponent from "components/StatsTableComponent";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { coinsDistributionStats } from "store/actions/additionalEarningAction";

const DistributedCoins = () => {
  const dispatch = useDispatch();
  const { distributionStats } = useSelector((state) => state.earnings);

  const currentYear = new Date().getFullYear();
  const allYears = Array.from({ length: 11 }, (_, i) => currentYear - 3 + i);

  const [selectedYear, setSelectedYear] = useState(currentYear.toString());
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [keyMaps, setKeyMaps] = useState({});
  const [formattedTransactions, setFormattedTransactions] = useState([]);

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  useEffect(() => {
    setLoading(true);
    dispatch(
      coinsDistributionStats(() => {
        setLoading(false);
      })
    );
  }, []);

  useEffect(() => {
    setColumns(["Year", "Total Coins", "Distributed Coins", "Remaining Coins"]);

    setKeyMaps({
      year: "Year",
      totalCoins: "Total Coins",
      distributedCoins: "Distributed Coins",
      remainingCoins: "Remaining Coins",
    });

    if (distributionStats?.length) {
      const formatted = distributionStats
        .filter((item) => {
          const date = new Date(item.startDate);
          return date.getFullYear() === parseInt(selectedYear);
        })
        .map((item) => {
          const date = new Date(item.startDate);
          return {
            year: date.getFullYear(),
            totalCoins: item.maxCoins?.toLocaleString() || "0",
            distributedCoins: item.coinsDistributed?.toLocaleString() || "0",
            remainingCoins: item.remainingCoins?.toLocaleString() || "0",
          };
        });

      setFormattedTransactions(formatted);
    } else {
      setFormattedTransactions([]);
    }
  }, [distributionStats, selectedYear]);

  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <Row className="mb-3">
          <Col sm="6" md="4">
            <FormGroup>
              <Label for="year">Select Year</Label>
              <Input
                type="select"
                name="year"
                id="year"
                value={selectedYear}
                onChange={handleYearChange}
              >
                {allYears.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>

        <h5>Distributed Coins</h5>
        <Card className="p-2">
          {loading ? (
            <div className="text-center my-5">
              <div className=" text-primary text-center">
                <Spinner size="md" />
              </div>
            </div>
          ) : formattedTransactions.length > 0 ? (
            <StatsTableComponent
              columns={columns}
              data={formattedTransactions}
              keyMap={keyMaps}
              loading={loading}
            />
          ) : (
            <p className="text-center my-3">
              <b>No data available for this year.</b>
            </p>
          )}
        </Card>
      </Container>
    </>
  );
};

export default DistributedCoins;
